(ns app.front.ui.content-switcher
  (:require [app.front.ui.util :as uiu]
            [core.front.carbon :as cc]
            [potpuri.core :as p]
            [reagent.core :as r]))

;; Implementation from `potpuri.core/find-index` but that is documented as taking vectors only:
(defn- index-of [items v]
  (first (keep-indexed (fn [i item] (when (= item v) i)) items)))

(def ^:private notification-dot-class
  "w-2 h-2 ml-1 rounded-full shrink-0 pointer-events-none")

(defn- sync-notification-dots!
  "Adds or removes notification dot elements inside content-switcher buttons.
   Each item can have :notification? true to show a dot inside the button."
  [container-el items]
  (when container-el
    (let [buttons (.querySelectorAll container-el ".bx--content-switcher-btn")]
      (doseq [idx (range (count items))]
        (when-let [btn (.item buttons idx)]
          (let [{:keys [notification?]} (nth items idx)
                existing                (.querySelector btn ".cs-notification-dot")]
            (cond
              (and notification? (not existing))
              (let [dot (js/document.createElement "span")]
                (set! (.-className dot) (str notification-dot-class " cs-notification-dot bg-ui-red"))
                (.appendChild btn dot))

              (and (not notification?) existing)
              (.removeChild btn existing))))))))

(defn content-switcher
  "Content switcher with optional per-item notification dots.
   Items can be plain values or maps with :value and :notification? keys.
   Plain values are equivalent to {:value v}."
  [{:keys [items] :or {}}]
  (let [*container (atom nil)
        normalize  (fn [item] (if (map? item) item {:value item}))]
    (r/create-class
      {:component-did-mount
       (fn [_] (sync-notification-dots! @*container (map normalize items)))

       :component-did-update
       (fn [this _]
         (let [{:keys [items]} (second (r/argv this))]
           (sync-notification-dots! @*container (map normalize items))))

       :reagent-render
       (fn [{:keys [items val->str current on-change class size] :or {val->str str}}]
         (let [normalized (map normalize items)
               values     (mapv :value normalized)]
           (when (seq (rest values))
             [:div.inline-flex {:class class
                                :ref   #(reset! *container %)}
              (apply cc/content-switcher
                     {:on-change      (fn [ev] (on-change (nth values (.-index ev))))
                      :selected-index (or (index-of values current) 0)
                      :class-name     (if (= size :large) "bx--content-switcher--large" "")}
                     (map (fn [{:keys [value notification?]}]
                            (let [label-text (val->str value)]
                              (cc/switch (p/assoc-if {:text label-text}
                                                     :data-cy (some->> value uiu/string-id (str "cs:"))
                                                     :class-name (when notification? "has-notification")))))
                          normalized))])))})))
